import React from 'react';

/**
 * One row of status tabs for list pages (drop-ins, tournaments, leagues),
 * easier to tap than a dropdown. "All" is the first tab and the default.
 *
 * @param {Array<{value: string, label: string}>} props.tabs  value '' = All
 * @param {string}   props.value
 * @param {Function} props.onChange  value → void
 * @param {string}   [props.label]   accessible name of the tab list
 */
const StatusTabs = ({ tabs, value, onChange, label = 'Status' }) => (
  <div
    role="tablist"
    aria-label={label}
    data-testid="status-tabs"
    style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem', margin: '0.5rem 0' }}
  >
    {tabs.map((tab) => {
      const active = (value || '') === tab.value;
      return (
        <button
          key={tab.value || 'all'}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(tab.value)}
          style={{
            padding: '0.35rem 0.9rem',
            borderRadius: '999px',
            fontSize: '0.85rem',
            fontWeight: 600,
            cursor: 'pointer',
            border: `1px solid ${active ? 'rgba(129,140,248,0.9)' : 'rgba(255,255,255,0.18)'}`,
            background: active ? 'rgba(99,102,241,0.35)' : 'rgba(255,255,255,0.05)',
            color: active ? '#fff' : 'rgba(255,255,255,0.75)',
          }}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);

export default StatusTabs;
